import Vue from "vue";
import router from "@/router";
import VueGtag from "vue-gtag";

Vue.use(
  VueGtag,
  {
    config: {
      id:
        process.env.NODE_ENV === "production"
          ? "UA-74065518-9"
          : "UA-74065518-10",
    },
  },
  router
);
